<template>
  <v-app>
    <v-main>
      <HomeView />
    </v-main>
  </v-app>
</template>

<script>
import HomeView from "./pages/HomeView.vue";

export default {
  name: "App",

  components: {
    HomeView,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
* {
  font-family: "Montserrat", sans-serif;
}

.v-application {
  font-family: "Montserrat", sans-serif;
}
</style>
